<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="devinfo" :rules="rules" ref="devrule" label-width="120px" class="">
			<el-row>
				<el-col :span="8">
					<el-form-item label="设备名称" prop="devname">
						<el-input clearable :disabled="!editok" v-model="devinfo.devname" maxlength="100"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="所属校区" prop="org">
						<el-cascader style="width: 100%;" :disabled="!editok" v-model="userorgid" :options="allOrgTree" :props="orgtreePro"  clearable></el-cascader>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="控制器id" prop="controlid">
						<el-input clearable :disabled="!editok" v-model="devinfo.controlid" maxlength="100"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="设备id" prop="devid">
						<el-input clearable :disabled="!editok" v-model="devinfo.devid" maxlength="100"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="图标url" prop="iconurl">
						<el-input clearable :disabled="!editok" v-model="devinfo.iconurl" ></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="排序" prop="idx">
						<el-input-number :disabled="!editok" v-model="devinfo.idx" :min="1" :max="999" :precision="2" :step="0.1" ></el-input-number>
						<!-- <el-input type="textarea" :rows="4" placeholder="请输入配置参数" maxlength="99999" clearable v-model="devinfo.value"></el-input> -->
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="首页显示" prop="defaultshow">
						<el-select style="width: 100%;" :disabled="!editok" v-model="devinfo.defaultshow" placeholder="请选择是否首页显示">
							<el-option v-for="item in showlist" :key="item.code" :label="item.name" :value="item.code"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button v-show="!editok" type="primary" @click="editok = true">修改</el-button>
			<el-button v-show="editok" plain @click="closeDlg">取消</el-button>
			<el-button v-show="editok" type="primary" @click="saveDevInfo">保存</el-button>
		</div>
	</div>
</template>

<script> 
	import { addDev,editDev } from '/static/apiUrl.js'
	export default {
		name : 'DevDetail',
		data() {
			return {
				editok: false,
				userorgid : [],
				disabled_cord: false,
				/* uploadheader : {
					Authorization: sessionStorage.getItem("authToken")
				},	 */
				showlist : [
					{
						code : 'Y',
						name : '显示'
					},
					{
						code : 'N',
						name : '不显示'
					}
				],
				orgtreePro : {
					checkStrictly: true,
					value : "id",
					label : "name",
					children : "children"
				},
				devinfo : {
					id: "",
					devname: "",
					orgid: "",
					controlid: "",
					devid : '',
					iconurl : '',
					idx : 0,
					defaultshow : ''
				},
				rules:{
					devname: [
						{ required: true, message: '请输入设备名称', trigger: 'blur' }
					],
					orgid: [
						{ required: true, message: '请选择校区', trigger: 'blur' }
					],
					controlid: [
						{ required: true, message: '请输入控制器id', trigger: 'blur' }
					],
					devid: [
						{ required: true, message: '请输入设备id', trigger: 'blur' }
					],
				}
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			selectedset: {
				type: Object,
				required: false
			},
			allOrgTree : {
				type : Array,
				required: true
			},
			add : {
				type : Boolean,
				required : false,
				default : false,
			}
		},
		watch: {
			add : {
				immediate: true,
				handler(newVal) {
					if(newVal == true){
						this.editok = true
					}else{
						this.editok = false
					}
				}
			},
			selectedset: {
				immediate: true,
				handler(newVal) {
					if(newVal != null){
						this.devinfo.id = newVal.id
						this.devinfo.devname=newVal.devname
						this.devinfo.orgid= newVal.orgid
						this.userorgid = newVal.orgid
						this.devinfo.controlid= newVal.controlid
						this.devinfo.devid = newVal.devid
						this.devinfo.iconurl = newVal.iconurl
						this.devinfo.defaultshow = newVal.defaultshow
						this.devinfo.idx = newVal.idx
					}else{
						this.devinfo.id = "",
						this.devinfo.devname="",
						this.devinfo.orgid= "",
						this.devinfo.controlid= "",
						this.devinfo.devid = '',
						this.devinfo.iconurl = '',
						this.devinfo.defaultshow = '',
						this.devinfo.idx = 0
					}
				}
			},
		},
		methods: {
			
			closeDlg() {
				this.editok = false
				if(this.add){
					this.$emit("needRefrash",false,false)
				}
			},
			saveDevInfo(){
				//this.editok = false
				this.$refs["devrule"].validate((valid) => {
					if (valid) {
						let checkok = true
						const isArr = Array.isArray(this.userorgid);
						if(isArr && this.userorgid.length > 0){
							this.devinfo.orgid = this.userorgid[this.userorgid.length-1]
						}else{
							this.devinfo.orgid = this.userorgid
						}
						
						if(this.devinfo.orgid == null || this.devinfo.orgid == ''){
							checkok = false
						}
						console.log(this.userorgid)
						if(!checkok){
							this.$message({
								showClose: true,
								message: "请完善数据信息",
								type: 'warning'
							});
						}else{
							if(this.devinfo.id != null && this.devinfo.id != ''){  //编辑
								editDev(this.devinfo).then(res => {
									if(0 == res.code){
										this.$message({
											showClose: true,
											message: "修改成功",
											type: 'success'
										});
										this.$emit("needRefrash",true,false)
									}else{
										this.$message({
											showClose: true,
											message: res.message,
											type: 'error'
										});
									}
								})
							}else{ //新增
								addDev(this.devinfo).then(res => {
									if(0 == res.code){
										this.$message({
											showClose: true,
											message: "添加成功",
											type: 'success'
										});
										this.$emit("needRefrash",true,false)
									}else{
										this.$message({
											showClose: true,
											message: res.message,
											type: 'error'
										});
									}
								})
							}
						}
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>